import type { SearchCombinedUnitMetadata } from '@atlassian/search-client/config';

import { getSiteCloudId, MAX_SELECTED_SITES } from '../../constants/filters/site';

/** The primary site plus the first other sites alphabetically, up to the selection cap. */
export const getDefaultSiteIds = (
	unitMetadata: readonly SearchCombinedUnitMetadata[] | undefined,
	currentCloudId: string | undefined,
): string[] => {
	const otherSites = [...(unitMetadata ?? [])]
		.filter((site) => getSiteCloudId(site.id) !== currentCloudId)
		.sort((a, b) => a.siteName.localeCompare(b.siteName));

	return Array.from(
		new Set([
			...(currentCloudId ? [currentCloudId] : []),
			...otherSites.map((site) => getSiteCloudId(site.id)),
		]),
	).slice(0, MAX_SELECTED_SITES);
};
